import "./AboutBrand.css";
const defaultItems = [
  {
    kicker: "RUMI",
    title: "SỨ MỆNH",
    body: "Rumi mang trong mình sứ mệnh nâng niu từng làn da non nớt của bé, mang đến sản phẩm tã bỉm được nghiên cứu và phát triển theo công nghệ Nhật Bản tiên tiến, để mỗi chiếc tã không chỉ là lớp bảo vệ mềm mại mà còn là lời ru êm dịu giúp con luôn khô thoáng, thoải mái, tự do khám phá thế giới tươi đẹp quanh mình. Với Rumi, chúng tôi muốn cùng cha mẹ tạo nên tuổi thơ hạnh phúc cho con nơi mỗi ngày trôi qua đều tràn ngập niềm vui, yêu thương và những kỷ niệm trong trẻo.",
  },
  {
    kicker: "RUMI",
    title: "TẦM NHÌN",
    body: "Rumi hướng tới trở thành thương hiệu tã bỉm Việt Nam được các mẹ tin yêu và lựa chọn không chỉ bởi chất lượng vượt trội, mà bởi tình cảm chân thành và triết lý “ru con trưởng thành” mà Rumi luôn giữ gìn. Chúng tôi mong muốn vươn xa hơn nữa, đem tình yêu thương và sự chăm sóc tận tâm đến với hàng triệu em bé trên khắp đất nước và khu vực, xây dựng một tương lai nơi mọi đứa trẻ đều được lớn lên trong sự êm dịu, an toàn và hạnh phúc trọn vẹn.",
  },
  {
    kicker: "RUMI",
    title: "GIÁ TRỊ CỐT LÕI",
    body: "Rumi lấy yêu thương làm nền tảng, an toàn làm cam kết, chất lượng làm trọng tâm và đồng hành làm sứ mệnh. Mỗi sản phẩm Rumi gửi đến tay cha mẹ đều chứa đựng tình yêu, sự tận tâm và trách nhiệm như lời hứa bền vững rằng Rumi sẽ luôn cùng mẹ nâng niu bé yêu trên từng bước trưởng thành, ru con khôn lớn bằng những điều tốt đẹp và dịu dàng nhất.",
  },
];

export default function AboutBrand({
  heading = "WE'LL BE EXPLORING.",
  items = defaultItems,
  className = "",
}) {
  return (
    <section className={`rumi-topics ${className}`}>
      <div className="rt-container">
        {/* <h2 className="rt-heading">{heading}</h2> */}

        <div className="rt-grid">
          {items.map((it, idx) => (
            <article key={idx} className="rt-card">
              <p className="rt-kicker">{it.kicker}</p>
              <h3 className="rt-title">{it.title}</h3>
              <span className="rt-underline" aria-hidden></span>
              <p className="rt-body">{it.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
